(ns practitest.frontend.components2.dashboard.charts.readiness-gauge.helpers)

(defn arc [{:config/keys [start-angle end-angle
                          arc-radius arc-weight]}]
  {:from     [:t 0]
   :to       [:t 1]
   :scale    [start-angle end-angle]
   :radius   arc-radius
   :weight   arc-weight
   :corner-r (* arc-weight 0.5)})

(defn tick [{:config/keys
             [tick-length tick-padding tick-inset
              start-angle end-angle
              arc-radius arc-weight]}]
  {:class  "tick"
   :scale  [(+ start-angle tick-inset) (- end-angle tick-inset)]
   :offset (- arc-radius arc-weight tick-padding)
   :length (- tick-length)})


